import { Stepper } from '@mantine/core';
import { StepData } from './StepData';
import { StepPay } from './StepPay';
import { StepInfo } from './StepInfo';
import { StepWait } from './StepWait';
import { StepQr } from './StepQr';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const PaymentFlow = () => {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const paymentIntent = JSON.parse(
      localStorage.getItem('payment_intent') || '""',
    );
    if (paymentIntent !== null && paymentIntent !== '') {
      setActive(2);
    }
  }, []);

  return (
    <Stepper active={active}>
      <Stepper.Step style={{ height: '100%' }}>
        <StepData
          forward={() => setActive(1)}
          back={() => void navigate('/welcome')}
        />
      </Stepper.Step>
      <Stepper.Step>
        <StepPay forward={() => setActive(2)} back={() => setActive(0)} />
      </Stepper.Step>
      <Stepper.Step>
        <StepInfo forward={() => setActive(3)} />
      </Stepper.Step>
      <Stepper.Step>
        <StepWait forward={() => setActive(4)} />
      </Stepper.Step>
      <Stepper.Step>
        <StepQr />
      </Stepper.Step>
    </Stepper>
  );
};
